var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"disabled":_vm.isDisabled,"loading":_vm.loading,"color":"primary"},on:{"click":function($event){_vm.submit()}}},[_vm._v("\n  "+_vm._s(_vm.$t(("buttons__" + (_vm.all ? 'export_all' : 'export'))))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }